<template>
    <div
        class="flex flex-col items-start justify-between md:flex-row"
        :class="{
            'items-stretch': !invoiceDetails,
            'items-start': invoiceDetails,
        }"
    >
        <div
            class="w-full rounded-[6px] border border-gray-300 md:mr-2 md:w-1/2 md:max-w-[462px] lg:mr-4 lg:w-full"
        >
            <PaymentMethods
                :subscription-type="preparedSubscription.subscription_plan.type"
                class="p-6"
                :billing-address="billingAddress"
                @select-payment-method="handleSelectPaymentMethod"
                @loading="paymentMethodsLoading = $event"
            />

            <div class="flex flex-col lg:flex-row lg:justify-between">
                <div v-show="!paymentMethodsLoading" class="w-full text-left">
                    <div class="border-t border-gray-300 p-6">
                        <CheckboxInput
                            v-model:checked="invoiceDetails"
                            size="lg"
                            name="invoiceDetails"
                            label="Add invoice details"
                        />
                    </div>

                    <InvoiceDetails
                        v-if="invoiceDetails"
                        :billing-address="billingAddress"
                        :countries="countries"
                        @updated-billing="emit('updatedBilling')"
                        @loading-invoice-details="
                            loadingInvoiceDetails = $event
                        "
                    />
                </div>
            </div>
        </div>

        <div
            class="mt-6 w-full rounded-[6px] border border-blue-200 bg-blue-100 px-6 pt-6 pb-5 md:mt-0 md:ml-2 md:w-1/2 md:max-w-[418px] md:px-9 lg:ml-4 lg:w-full min-h-[380px]"
        >
            <h4
                class="text-lg font-medium leading-normal tracking-tighter text-gray-800"
            >
                Summary
            </h4>

            <div class="border-b border-blue-200">
                <div class="mt-4 flex items-start justify-between pb-[14px]">
                    <div>
                        <p
                            class="text-sm font-medium leading-normal text-gray-800"
                        >
                            Topol
                            {{ preparedSubscription.subscription_plan.name }}
                        </p>
                        <p
                            v-if="
                                preparedSubscription.subscription_plan.type ===
                                    'pro' && !personal
                            "
                            class="mt-[3px] text-sm leading-normal text-gray-500"
                        >
                            with
                            {{
                                preparedSubscription.additional_users_to_pay_count >=
                                0
                                    ? preparedSubscription.additional_users_to_pay_count
                                    : 0
                            }}
                            team seats (+3 seats free)
                        </p>
                        <p
                            class="mt-[3px] text-sm leading-normal text-gray-500"
                        >
                            <span
                                v-if="
                                    [
                                        'plugin_startup_monthly',
                                        'plugin_expansion_monthly',
                                        'plugin_business_monthly',
                                    ].includes(
                                        preparedSubscription.subscription_plan
                                            .uuid
                                    )
                                "
                            >
                                {{
                                    preparedSubscription.subscription_plan
                                        .users_limit
                                }}
                            </span>
                            <span
                                v-if="
                                    preparedSubscription.subscription_plan.uuid.includes(
                                        'unlimited'
                                    )
                                "
                            >
                                Unlimited
                            </span>
                            <span
                                v-if="
                                    preparedSubscription.subscription_plan
                                        .type === 'plugin'
                                "
                            >
                                users included in plan.
                            </span>
                        </p>

                        <p
                            class="mt-[3px] text-sm leading-normal text-gray-500"
                        >
                            {{
                                preparedSubscription.subscription_plan
                                    .period === 12
                                    ? 'Annual'
                                    : 'Monthly'
                            }}
                            plan renews
                            {{ format(new Date(date), 'MMMM d, yyyy') }}
                        </p>
                    </div>

                    <div
                        class="text-sm font-medium leading-normal text-gray-800"
                    >
                        ${{ (updatedSubscription ? updatedSubscription.real_total_without_sale : preparedSubscription.real_total_without_sale) }}/{{
                            preparedSubscription.subscription_plan.period === 1
                                ? 'month'
                                : 'year'
                        }}
                    </div>
                </div>

                <!-- <div
                    v-if="preparedSubscription.discount !== 0"
                    class="-mt-1 flex justify-between pb-[14px] text-sm font-bold text-gray-800"
                >
                    <p>BLACK FRIDAY</p>
                    <p>-${{ preparedSubscription.real_discount_with_tax }}</p>
                </div> -->
            </div>

            <!-- Coupon Section - Separate Section -->
            <div class="border-b border-blue-200 pb-4 mt-4">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                        <!-- Green Checkmark Icon -->
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 0C11.4062 0 12.6562 0.820312 13.2812 2.03125C14.5703 1.60156 16.0547 1.91406 17.0703 2.92969C18.0859 3.94531 18.3984 5.42969 17.9688 6.71875C19.1797 7.34375 20 8.59375 20 10C20 11.4453 19.1797 12.6953 17.9688 13.3203C18.3984 14.6094 18.0859 16.0547 17.0703 17.0703C16.0547 18.0859 14.5703 18.3984 13.2812 18.0078C12.6562 19.2188 11.4062 20 10 20C8.55469 20 7.30469 19.2188 6.67969 18.0078C5.39062 18.3984 3.94531 18.0859 2.92969 17.0703C1.91406 16.0547 1.60156 14.6094 1.99219 13.3203C0.78125 12.6953 0 11.4453 0 10C0 8.59375 0.78125 7.34375 1.99219 6.71875C1.60156 5.42969 1.91406 3.94531 2.92969 2.92969C3.94531 1.91406 5.39062 1.60156 6.67969 2.03125C7.30469 0.820312 8.55469 0 10 0ZM7.5 8.75C8.16406 8.75 8.75 8.20312 8.75 7.5C8.75 6.83594 8.16406 6.25 7.5 6.25C6.79688 6.25 6.25 6.83594 6.25 7.5C6.25 8.20312 6.79688 8.75 7.5 8.75ZM13.75 12.5C13.75 11.8359 13.1641 11.25 12.5 11.25C11.7969 11.25 11.25 11.8359 11.25 12.5C11.25 13.2031 11.7969 13.75 12.5 13.75C13.1641 13.75 13.75 13.2031 13.75 12.5ZM13.1641 8.16406C13.5156 7.8125 13.5156 7.22656 13.1641 6.875C12.7734 6.48438 12.1875 6.48438 11.8359 6.875L6.83594 11.8359C6.44531 12.2266 6.44531 12.8125 6.83594 13.1641C7.1875 13.5547 7.77344 13.5547 8.125 13.1641L13.1641 8.16406Z" fill="#12B76A"/>
</svg>
                        <!-- Coupon Text -->
                        <span class="text-sm font-medium text-gray-700">
                            {{ appliedCoupon ? `Coupon applied: ${appliedCoupon}` : 'Discount coupon' }}
                        </span>
                    </div>
                    
                    <!-- Insert Coupon Button -->
                    <button
                        v-if="!showCouponInput && !appliedCoupon"
                        class="px-3 py-1 text-sm text-blue-600 hover:text-blue-700 font-medium border border-blue-600 hover:border-blue-700 rounded-[4px] transition-colors"
                        type="button"
                        @click="showCouponInput = true"
                    >
                        Apply coupon
                    </button>
                    
                    <!-- Cancel Button -->
                    <button
                        v-if="showCouponInput && !appliedCoupon"
                        class="text-sm text-blue-600 hover:text-blue-700 font-medium"
                        type="button"
                        @click="cancelCoupon"
                    >
                        Cancel
                    </button>
                    
                    <!-- Remove Coupon Button -->
                    <button
                        v-if="appliedCoupon"
                        class="text-xs text-gray-500 hover:text-red-600"
                        type="button"
                        @click="removeCoupon"
                    >
                        Remove
                    </button>
                </div>

                <!-- Applied Coupon Discount Display -->
                <div v-if="appliedCoupon && updatedSubscription" class="mt-1 ml-6">
                    <div class="text-xs text-green-600">
                        Save {{ discountPercentage }}% (${{ discountAmount }})
                    </div>
                </div>

                <!-- Coupon Input -->
                <div v-if="showCouponInput && !appliedCoupon" class="mt-4 mb-4">
                    <div class="flex gap-3 items-center">
                        <TextInput
                            v-model="couponCode"
                            name="couponCode"
                            placeholder="Enter coupon code"
                            class="flex-1"
                            :error="couponError"
                        />
                        <button
                            :disabled="!couponCode.trim() || loadingCoupon"
                            class="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm font-medium rounded-[4px] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            type="button"
                            @click="applyCoupon"
                        >
                            {{ loadingCoupon ? 'Applying...' : 'Apply' }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="mt-5">
                <div class="flex justify-between">
                    <div
                        class="text-sm leading-normal tracking-tighter text-gray-800"
                    >
                        Subtotal
                    </div>
                    <div class="text-sm text-gray-800">
                        ${{ (updatedSubscription ? updatedSubscription.subtotal / 100 : preparedSubscription.subtotal / 100) }}
                    </div>
                </div>
                <div class="flex justify-between">
                    <div
                        class="text-lg font-medium leading-normal tracking-tighter text-gray-800"
                    >
                        {{ (updatedSubscription ? updatedSubscription.subtotal : preparedSubscription.subtotal) !== (updatedSubscription ? updatedSubscription.total : preparedSubscription.total) ? 'Total (incl. tax)' : 'Total' }}
                    </div>
                    <div class="text-lg font-bold text-gray-800">
                        ${{ (updatedSubscription ? updatedSubscription.total / 100 : preparedSubscription.total / 100) }}
                    </div>
                </div>
                <div class="mt-6">
                    <button
                        :disabled="
                            loading ||
                            loadingInvoiceDetails ||
                            !selectedCard.token ||
                            paymentMethodsLoading
                        "
                        class="flex h-15 w-full items-center justify-center rounded-[6px] bg-[#4299E1] text-center text-lg font-bold text-white transition duration-200 ease-in-out hover:shadow-button focus:ring-2 focus:ring-[#4299E1] focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-white"
                        @click="handleSubmit"
                    >
                        <div class="relative">
                            Subscribe now

                            <LoadingSpinner
                                v-if="loading || loadingInvoiceDetails"
                                size="medium"
                                class="absolute right-[-40px] top-0 hidden sm:block"
                            />
                        </div>
                    </button>

                    <div class="mt-5 pb-3 text-xs text-gray-500">
                        You’ll be charged for individual products at the end of
                        their free trial(s). Your subscription will continue
                        until you cancel.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { create } from '@composables/useNotifications';

import { PropType, onMounted } from 'vue';
import { route } from 'ziggy-js';
import axios from 'axios';

import BillingAddress from '@/types/Subscription/BillingAddress';
import ISelectable from '@/types/Atomic/ISelectable';
import PreparedSubscription from '@/types/Subscription/PreparedSubscription';
import { router } from '@inertiajs/vue3';
import {
    ICreditCardPaymentMethod,
    IPaymentMethod,
    IStripeCreditCardPaymentMethod,
} from '@/types/Subscription/IPaymentMethod';
import { add, format } from 'date-fns';
import { useGtm } from '@/composables/useGtm';

import { useBraintreeClient } from '@/composables/useBraintree';

interface ISelectedCard {
    id: string;
    token: string;
    type: 'Card' | 'PayPal' | '';
}

const props = defineProps({
    billingAddress: {
        required: true,
        type: Object as PropType<BillingAddress>,
    },
    subscriptionPlanUuid: {
        required: true,
        type: String,
    },
    preparedSubscription: {
        required: true,
        type: Object as PropType<PreparedSubscription>,
    },
    countries: {
        required: true,
        type: Array as PropType<ISelectable[]>,
    },
    seats: {
        required: false,
        type: Number,
        default: 0,
    },
    personal: {
        required: false,
        type: Boolean,
        default: false,
    },
    autoCoupon: {
        required: false,
        type: String,
        default: null,
    },
});

const emit = defineEmits(['success', 'error', 'updatedBilling']);

const { teamFeatureDisabled } = useFeatures();
const { pushEvent } = useGtm();

const isStripeEnabled = !teamFeatureDisabled('stripe');
const paymentMethodsLoading = ref(true);
const invoiceDetails = ref(false);
const loadingInvoiceDetails = ref(false);
const loading = ref(false);
const selectedCard = ref({ id: '', token: '', type: '' } as ISelectedCard);
const couponCode = ref('');
const showCouponInput = ref(false);
const appliedCoupon = ref('');
const couponError = ref('');
const loadingCoupon = ref(false);
const updatedSubscription = ref<PreparedSubscription | null>(null);

const { createClient, verifyCardByToken } = useBraintreeClient(
    props.preparedSubscription.subscription_plan.type
);

const { confirmStripeCardPayment } = useStripeClient(
    props.preparedSubscription.subscription_plan.type
);

// Auto-apply coupon if provided
onMounted(() => {
    if (props.autoCoupon && props.autoCoupon.trim()) {
        couponCode.value = props.autoCoupon.trim();
        applyCoupon();
    }
});

const date = computed(() => {
    if (props.preparedSubscription.subscription_plan.period === 1) {
        return add(new Date(), {
            months: 1,
        });
    } else
        return add(new Date(), {
            years: 1,
        });
});

const discountAmount = computed(() => {
    if (!updatedSubscription.value || !appliedCoupon.value) return '0.00';
    
    const originalTotal = props.preparedSubscription.total / 100;
    const discountedTotal = updatedSubscription.value.total / 100;
    const discount = originalTotal - discountedTotal;
    return discount.toFixed(2);
});

const discountPercentage = computed(() => {
    if (!updatedSubscription.value || !appliedCoupon.value) return 0;
    
    const originalTotal = props.preparedSubscription.total / 100;
    const discountedTotal = updatedSubscription.value.total / 100;
    const discount = originalTotal - discountedTotal;
    const percentage = (discount / originalTotal) * 100;
    return Math.round(percentage);
});

const handleSelectPaymentMethod = (paymentMethod: IPaymentMethod) => {
    selectedCard.value = {
        id: (paymentMethod as IStripeCreditCardPaymentMethod)?.id,
        token: paymentMethod.token,
        type:
            (paymentMethod as ICreditCardPaymentMethod).last4 !== undefined
                ? 'Card'
                : 'PayPal',
    };
};

const handleSubmit = async () => {
    if (selectedCard.value === null) {
        return;
    }

    try {
        loading.value = true;

        if (isStripeEnabled) {
            await buySubscriptionWithStripe();
        } else {
            await buySubscriptionWithBraintree();
        }
    } catch (err) {
        return;
    } finally {
        loading.value = false;
    }
};

const buySubscriptionWithStripe = async () => {
    return new Promise((resolve, reject) => {
        router.post(
            route('stripe.subscriptions.store'),
            {
                subscription_plan_uuid:
                    props.preparedSubscription.subscription_plan.uuid,
                payment_method_id: selectedCard.value.id,
                coupon_code: appliedCoupon.value || null,
            },
            {
                preserveScroll: true,
                onSuccess: async (response) => {
                    if (
                        response.props.flash.data.paymentIntent.status ===
                        'requires_confirmation'
                    ) {
                        const result = await confirmStripeCardPayment(
                            response.props.flash.data.paymentIntent
                                .client_secret
                        );

                        if (!result) {
                            emit(
                                'error',
                                'Verifying card with 3D Secure failed'
                            );
                            create({
                                title: 'Subscription not created',
                                text:
                                    'Following error occurred "' +
                                    'Verifying card with 3D Secure failed' +
                                    '" when creating your subscription.',
                                type: 'error',
                            });
                            reject(response);
                            return;
                        }

                        router.post(
                            route(
                                'stripe.subscriptions.complete',
                                response.props.flash.data.subscription.id
                            )
                        );
                    }

                    pushEvent('topol_purchase_first', {
                        type: props.preparedSubscription.subscription_plan.type,
                        amountPaid: props.preparedSubscription.total / 100,
                        planType:
                            props.preparedSubscription.subscription_plan
                                .period === 1
                                ? 'monthly'
                                : 'yearly',
                        currency: 'USD',
                    });

                    emit('success');
                    create({
                        title: 'Subscription created',
                        text: 'Your subscription has been successfully created.',
                        type: 'success',
                    });
                    fetchBanners();
                    resolve(response);
                },
                onError: (response) => {
                    emit('error', response.message);
                    create({
                        title: 'Subscription not created',
                        text:
                            'Following error occurred "' +
                            response.message +
                            '" when creating your subscription.',
                        type: 'error',
                    });
                    reject(response);
                },
            }
        );
    });
};

const buySubscriptionWithBraintree = async () => {
    await createClient({ enableHostedFields: false });

    let verifyCardResponse = undefined;

    if (selectedCard.value.type === 'Card') {
        verifyCardResponse = await verifyCardByToken({
            token: selectedCard.value.token,
            amount: props.preparedSubscription.total,
        });
    }

    return new Promise((resolve, reject) => {
        router.post(
            route('subscriptions.store'),
            {
                subscription_plan_uuid: props.subscriptionPlanUuid,
                type: selectedCard.value.type,
                nonce: verifyCardResponse ? verifyCardResponse.nonce : '',
                token: selectedCard.value.token,
                additional_users: props.seats,
            },
            {
                preserveScroll: true,
                onSuccess: async (response) => {
                    emit('success');
                    create({
                        title: 'Subscription created',
                        text: 'Your subscription has been successfully created.',
                        type: 'success',
                    });
                    fetchBanners();
                    resolve(response);
                },
                onError: (response) => {
                    emit('error', response.message);
                    create({
                        title: 'Subscription not created',
                        text:
                            'Following error occurred "' +
                            response.message +
                            '" when creating your subscription.',
                        type: 'error',
                    });
                    reject(response);
                },
            }
        );
    });
};

const fetchBanners = () => {
    const { fetchBanners } = useBanners();
    const { fetchSubscriptions } = useSubscriptions();
    fetchBanners();
    fetchSubscriptions();
};

// Coupon management functions
const applyCoupon = async () => {
    if (!couponCode.value.trim()) return;
    
    loadingCoupon.value = true;
    couponError.value = '';
    
    try {
        const response = await axios.get(route('subscriptions.prepare', {
            subscription_plan_uuid: props.preparedSubscription.subscription_plan.uuid,
            coupon_code: couponCode.value.trim(),
        }));
        
        updatedSubscription.value = response.data.data;
        appliedCoupon.value = couponCode.value.trim();
        showCouponInput.value = false;
        couponCode.value = '';
        
        create({
            title: 'Coupon applied',
            text: `Coupon "${appliedCoupon.value}" has been applied successfully.`,
            type: 'success',
        });
    } catch (error) {
        if (error.response?.status === 422) {
            couponError.value = 'Invalid coupon code';
        } else if (error.response?.data?.message) {
            couponError.value = error.response.data.message;
        } else {
            couponError.value = 'Failed to apply coupon. Please try again.';
        }
        
        create({
            title: 'Coupon not applied',
            text: couponError.value,
            type: 'error',
        });
    } finally {
        loadingCoupon.value = false;
    }
};

const cancelCoupon = () => {
    showCouponInput.value = false;
    couponCode.value = '';
    couponError.value = '';
};

const removeCoupon = () => {
    appliedCoupon.value = '';
    updatedSubscription.value = null;
    couponCode.value = '';
    couponError.value = '';
    showCouponInput.value = false;
    
    create({
        title: 'Coupon removed',
        text: 'The coupon has been removed from your subscription.',
        type: 'info',
    });
};
</script>

<style scoped>
div.braintree-hosted-fields-focused {
    border: 1px solid #63b3ed;
}

div.braintree-hosted-fields-invalid {
    border: 1px solid #e02424;
}
</style>
